import React from 'react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-darkCard border-t border-white/5 py-8 px-4 text-center" data-id="element-32">
      <div className="max-w-4xl mx-auto" data-id="element-33">
        <p className="text-gray-400 font-medium text-sm mb-2" data-id="element-34">
          © {currentYear} Todos los derechos reservados.
        </p>
        <p className="text-gray-600 text-xs max-w-2xl mx-auto" data-id="element-35">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}